import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IChapter } from 'rev-shared/media/videoChapter/IChapter';
import { VideoChaptersModel } from 'rev-shared/media/videoChapter/VideoChaptersModel';

import styles from './video-chapters.module.less';

@Component({
	selector: 'video-chapters',
	templateUrl: './VideoChapters.Component.html'
})

export class VideoChaptersComponent {
	@Input() public chapterInfo: VideoChaptersModel;
	@Output() public onChapterClick: EventEmitter<any> = new EventEmitter();

	public readonly styles = styles;

	public clickChapter(chapter: IChapter, index: number): void {
		this.chapterInfo.focusChapter(index);

		this.onChapterClick.emit({
			time: chapter.time
		});
	}
}
